import styled from 'styled-components';

export const ProfileMenuIconBox = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 50%;
`;
